import type { ConceptDef } from '../types';

const chain = (id: string, name: string, label: string, items: string[]): ConceptDef => ({
  kind: 'taskChain',
  id,
  label: name,
  category: 'Daily living',
  description: `${label}, one step at a time. The adult notes how much help each step needed.`,
  config: { sequences: [{ label, items }], promptMode: 'AUDIO' },
});

export const chainHands = chain('chain-handwashing', 'Step by Step: Washing Hands', 'Wash hands', ['🚰 Turn on the tap', '💧 Wet your hands', '🧼 Use soap', '👐 Rub your hands', '🔁 Rub between fingers', '💦 Rinse the soap off', '🚰 Turn off the tap', '🧻 Dry your hands']);
export const chainTeeth = chain('chain-teeth', 'Step by Step: Brushing Teeth', 'Brush teeth', ['🪥 Get your toothbrush', '🧴 Put on toothpaste', '😁 Brush the front', '👄 Brush the sides', '🦷 Brush the back', '💦 Spit', '🚰 Rinse the brush', '🗄️ Put it away']);
export const chainCoat = chain('chain-coat', 'Step by Step: Putting On a Coat', 'Put on a coat', ['🧥 Hold the coat', '👉 One arm in', '👈 Other arm in', '⬆️ Pull it on', '🤐 Do up the zip']);
export const chainToast = chain('chain-toast', 'Step by Step: Making Toast', 'Make toast', ['🍞 Get the bread', '📥 Put it in the toaster', '⬇️ Push the lever', '⏳ Wait', '🍽️ Put it on a plate', '🧈 Spread butter']);
export const chainBag = chain('chain-bag', 'Step by Step: Packing a School Bag', 'Pack the school bag', ['📚 Book', '✏️ Pencil case', '🥪 Lunch box', '💧 Water bottle', '🎒 Close the bag']);
export const chainToilet = chain('chain-toilet', 'Step by Step: Using the Toilet', 'Use the toilet', ['🚪 Go to the toilet', '👖 Pull clothes down', '🚽 Sit on the toilet', '🧻 Wipe', '👖 Pull clothes up', '🔽 Flush', '🧼 Wash hands']);

const wait = (id: string, name: string, minWait: number, maxWait: number, prompt: string): ConceptDef => ({
  kind: 'waitForGo',
  id,
  label: name,
  category: 'Social',
  description: 'Wait until the button turns green, then tap it.',
  config: { minWait, maxWait, rounds: 5, prompts: [{ prompt }] },
});

export const waitShort = wait('wait-short', 'Wait for Go: Short Waits', 2, 5, 'Wait for green');
export const waitLong = wait('wait-long', 'Wait for Go: Longer Waits', 5, 10, 'Hands still — wait for green');
export const waitTurn = wait('wait-turn', 'Wait for Go: My Turn', 3, 8, 'Wait for your turn');
